import React, { useState } from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';

import adminApi from '../../Api/adminApi';
import useAdminStyles from './adminStyles';
import useAdminQuery from './useAdminQuery';
import StateCard from './StateCard';
import AddEditSubscription from './AddEditSubscription';

const yesNo = (val) => (val ? 'Yes' : 'No');
const limit = (val) => (val === -1 || val === '-1' ? 'Unlimited' : val);

/**
 * The plan catalogue (subscription_types): limits and feature flags per plan,
 * with the Stripe prices read at startup.
 */
const PlanDefinitions = () => {
    const classes = useAdminStyles();
    const [editing, setEditing] = useState(null);
    const { data, isLoading, isError, isForbidden, reload } = useAdminQuery(() => adminApi.getSubscriptionTypes(), []);

    if (!data) {
        return <StateCard isLoading={isLoading} isError={isError} isForbidden={isForbidden} />;
    }

    const plans = Object.keys(data.subscriptions || {})
        .map((key) => data.subscriptions[key])
        .filter(Boolean);
    const pricing = data.pricing || {};

    const priceText = (plan) => {
        const prices = pricing[plan.subscriptionName];
        if (!prices || prices.length === 0) {
            return '—';
        }
        return prices.map((p) => `${p.unit_amount / 100} ${p.currency.toUpperCase()}/${p.interval}`).join(', ');
    };

    return (
        <div className={classes.card} style={{ padding: 0, overflowX: 'auto' }}>
            <Table size="small">
                <TableHead>
                    <TableRow>
                        <TableCell>Plan</TableCell>
                        <TableCell>Price</TableCell>
                        <TableCell>Groups</TableCell>
                        <TableCell>Library</TableCell>
                        <TableCell>Saved sessions</TableCell>
                        <TableCell>Individual boards</TableCell>
                        <TableCell>PDF</TableCell>
                        <TableCell>Audio/video</TableCell>
                        <TableCell>Math + AI</TableCell>
                        <TableCell>Stripe product</TableCell>
                        <TableCell />
                    </TableRow>
                </TableHead>
                <TableBody>
                    {plans.map((plan) => (
                        <TableRow key={plan.id}>
                            <TableCell>
                                <strong>{plan.subscriptionName}</strong>
                                {plan.active ? '' : ' (inactive)'}
                            </TableCell>
                            <TableCell>{priceText(plan)}</TableCell>
                            <TableCell>{limit(plan.groupCount)}</TableCell>
                            <TableCell>{limit(plan.collectionCount)}</TableCell>
                            <TableCell>{limit(plan.savedMultiBoardSessionCount)}</TableCell>
                            <TableCell>{yesNo(plan.multipleIndividualBoards)}</TableCell>
                            <TableCell>{yesNo(plan.pdfDownload)}</TableCell>
                            <TableCell>{yesNo(plan.audioVideo)}</TableCell>
                            <TableCell>{yesNo(plan.mathConverter)}</TableCell>
                            <TableCell className={classes.mono}>{plan.subscriptionStripeId}</TableCell>
                            <TableCell align="right">
                                <Button size="small" variant="outlined" onClick={() => setEditing(plan)}>
                                    Edit
                                </Button>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
            <Dialog open={!!editing} onClose={() => setEditing(null)} fullWidth maxWidth="xs">
                {editing ? (
                    <>
                        <DialogTitle>Edit {editing.subscriptionName}</DialogTitle>
                        <DialogContent>
                            <AddEditSubscription
                                subscription={editing}
                                pricing={pricing}
                                handleClose={() => setEditing(null)}
                                onSaved={reload}
                            />
                        </DialogContent>
                    </>
                ) : null}
            </Dialog>
        </div>
    );
};

export default PlanDefinitions;
